module.exports = __webpack_public_path__ + "media/images/page_4-0a6c8895ca1a5c90011052b0d7744821.jpg";